/**
 * @generated SignedSource<<982ab3cf75f2b9bb6a329ab205d55fe3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTypeEnum = "assignment" | "call" | "change" | "create_user" | "email" | "match" | "note" | "offer" | "origination" | "requalification" | "task" | "visit";
export type EmailVisibilityTypeEnum = "organisation" | "private" | "shared";
export type OfferStatus = "accepted" | "pending" | "refused";
export type ParticipantStatus = "maybe" | "no" | "noreply" | "yes";
export type UpsertActivityInput = {
  activity: ActivityInput;
  clientMutationId?: string | null;
  notifyParticipants?: boolean | null;
};
export type ActivityInput = {
  activityType?: ActivityTypeEnum | null;
  assignedTo?: string | null;
  createdBy?: string | null;
  done?: boolean | null;
  doneAt?: string | null;
  dueAt?: string | null;
  endAt?: string | null;
  endDate?: string | null;
  id?: string | null;
  location?: string | null;
  note?: string | null;
  offerStatus?: OfferStatus | null;
  parentId?: string | null;
  participants?: ReadonlyArray<ActivityParticipantInput | null> | null;
  pinned?: boolean | null;
  startDate?: string | null;
  subject?: string | null;
  success?: boolean | null;
  visibility?: EmailVisibilityTypeEnum | null;
};
export type ActivityParticipantInput = {
  email?: string | null;
  id?: string | null;
  name?: string | null;
  status?: ParticipantStatus | null;
};
export type ActivityEventFormUpsertMutation$variables = {
  input: UpsertActivityInput;
};
export type ActivityEventFormUpsertMutation$data = {
  readonly upsertActivity: {
    readonly activity: {
      readonly buyerLead: {
        readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_buyerLead">;
      } | null;
      readonly enquiry: {
        readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_enquiry">;
      } | null;
      readonly id: string;
      readonly lead: {
        readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_lead">;
      } | null;
      readonly lot: {
        readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_lot">;
      } | null;
      readonly user: {
        readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_user">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ActivityEventForm_activity">;
    } | null;
  } | null;
};
export type ActivityEventFormUpsertMutation = {
  response: ActivityEventFormUpsertMutation$data;
  variables: ActivityEventFormUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "primaryEmail",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v2/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Subscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v20 = [
  (v2/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/),
  (v17/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ActivityParticipant",
  "kind": "LinkedField",
  "name": "displayParticipants",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ActivityParticipant",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v27 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lotReference",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "broker",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityEventFormUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ActivityEventForm_activity"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Enquiry",
                "kind": "LinkedField",
                "name": "enquiry",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityEventForm_enquiry"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lot",
                "kind": "LinkedField",
                "name": "lot",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityEventForm_lot"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lead",
                "kind": "LinkedField",
                "name": "lead",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityEventForm_lead"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityEventForm_user"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerLead",
                "kind": "LinkedField",
                "name": "buyerLead",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityEventForm_buyerLead"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivityEventFormUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActivity"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canEditVisibility",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v27/*: any*/),
                "type": "ActivityTask",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v27/*: any*/),
                "type": "ActivityCall",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ],
                "type": "ActivityVisit",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Enquiry",
                "kind": "LinkedField",
                "name": "enquiry",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lot",
                "kind": "LinkedField",
                "name": "lot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "salePrice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mandateType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fixedFee",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commissionRate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PropertyImage",
                    "kind": "LinkedField",
                    "name": "primaryPropertyImage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "offers",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lead",
                "kind": "LinkedField",
                "name": "lead",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerLead",
                "kind": "LinkedField",
                "name": "buyerLead",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lot",
                    "kind": "LinkedField",
                    "name": "lot",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v28/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b8e3d926e09bc72df1bbe508350d1379",
    "id": null,
    "metadata": {},
    "name": "ActivityEventFormUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation ActivityEventFormUpsertMutation(\n  $input: UpsertActivityInput!\n) {\n  upsertActivity(input: $input) {\n    activity {\n      __typename\n      id\n      ...ActivityEventForm_activity\n      enquiry {\n        ...ActivityEventForm_enquiry\n        id\n      }\n      lot {\n        ...ActivityEventForm_lot\n        id\n      }\n      lead {\n        ...ActivityEventForm_lead\n        id\n      }\n      user {\n        ...ActivityEventForm_user\n        id\n      }\n      buyerLead {\n        ...ActivityEventForm_buyerLead\n        id\n      }\n    }\n  }\n}\n\nfragment ActivityEventForm_activity on Activity {\n  __isActivity: __typename\n  id\n  visibility\n  canEditVisibility\n  ... on ActivityTask {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n  ... on ActivityCall {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n  ... on ActivityVisit {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    endDate\n    endAt\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n}\n\nfragment ActivityEventForm_buyerLead on BuyerLead {\n  id\n  user {\n    firstName\n    lastName\n    id\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  lot {\n    lotReference\n    title\n    id\n  }\n  __typename\n}\n\nfragment ActivityEventForm_enquiry on Enquiry {\n  __typename\n  id\n}\n\nfragment ActivityEventForm_lead on Lead {\n  id\n  property {\n    formattedAddress\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  __typename\n}\n\nfragment ActivityEventForm_lot on Lot {\n  id\n  title\n  lotReference\n  salePrice\n  mandateType\n  fixedFee\n  commissionRate\n  property {\n    id\n    formattedAddress\n  }\n  primaryPropertyImage {\n    image {\n      url\n      id\n    }\n    id\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  seller {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  offers {\n    status\n    amount\n    createdAt\n    id\n  }\n  __typename\n}\n\nfragment ActivityEventForm_user on User {\n  id\n  firstName\n  lastName\n  primaryEmail {\n    email\n    id\n  }\n  primaryImage {\n    url\n    id\n  }\n  organisation {\n    name\n    formattedAddress\n    id\n  }\n  subscription {\n    status\n    id\n  }\n  __typename\n}\n"
  }
};
})();

(node as any).hash = "739484dad6a156b2bc5c6364bc030daf";

export default node;
